/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DiskUtilizationSetting {
    getFixupPrototypeFunction() { return DiskUtilizationSetting.fixupPrototype; }

    static newInstance(model: Partial<DiskUtilizationSetting>): DiskUtilizationSetting {
        let obj = Object.assign(new DiskUtilizationSetting(), model);
        DiskUtilizationSetting.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DiskUtilizationSetting>): DiskUtilizationSetting {
        if (!model) return null;
        return DiskUtilizationSetting.newInstance(<DiskUtilizationSetting> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DiskUtilizationSetting) {
        if (!obj) return;

        models.DiskUtilizationSetting.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DiskUtilizationSetting): boolean {
        Object.setPrototypeOf(obj, DiskUtilizationSetting.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.settings) {
            for (let val of this.settings) {
                models.DiskUtilizationWorkspaceConfiguration.fixupPrototype(val);
            }
        }
    }

    settings: Array<models.DiskUtilizationWorkspaceConfiguration>;

}
